/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import CardMessageNoAvatar from 'DesignSystem/CardMessageNoAvatar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Status/Content/Loading"
  
}) {
  return (<React.Fragment
>
<CardMessageNoAvatar
  viewPath={`${viewPath}/CardMessageNoAvatar`}
 marginTop={16}
 marginBottom={8}
 marginLeft={30}
 alignSelf="flex-end"
 maxWidth={600}
 backgroundColor="rgba(0,0,0,0.02)"
/>
{children}
</React.Fragment>)
}